import Card from "#/components/shared/card";
import Typography from "#/components/shared/typography";
import { AssistantMessage } from "./RealtimeContext";

export default function RealtimeEventLog({
  messages,
}: {
  messages: AssistantMessage[];
}) {
  return (
    <Card className="w-full" variant="default" elevation={1}>
      <Card.Header variant="default">
        <Typography variant="h4" className="text-terracotta">
          Event log
        </Typography>
      </Card.Header>
      <Card.Body className="space-y-3">
        {messages.length === 0 ? (
          <Typography variant="body2" className="text-brown-600">
            No events yet. Start a session to see assistant text and raw events.
          </Typography>
        ) : (
          <ul className="space-y-2">
            {messages.map((msg, idx) => (
              <li
                key={`${msg.type}-${idx}-${
                  msg.type === "assistant_text" ? msg.text : ""
                }`}
                className="rounded-lg border border-cream-200 bg-cream-50 px-3 py-2"
              >
                {msg.type === "assistant_text" ? (
                  <Typography variant="body2" className="text-brown-800">
                    Assistant: {msg.text}
                  </Typography>
                ) : (
                  <Typography variant="body2" className="text-brown-700">
                    {msg.text}
                  </Typography>
                )}
              </li>
            ))}
          </ul>
        )}
      </Card.Body>
    </Card>
  );
}
